// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__grotesque_30a9ab', '__grotesque_Fallback_30a9ab'"},"className":"__className_30a9ab","variable":"__variable_30a9ab"};